import { CABIN } from '../constants';

export function getCabinOptionTitle({ type, persons, cabinType }) {
  if (cabinType === CABIN.SOLO_TYPE) {
    return type === 'girl' ? 'Solo spot - Female' : 'Solo spot - Male';
  }

  if (type === 'mixed') {
    return 'Cabin - Mix';
  }
  if (type === 'girl') {
    return Number(persons) === 2 ? 'Cabin - Female' : 'Solo Cabin - Female';
  }
  return Number(persons) === 2 ? 'Cabin - Male' : 'Solo Cabin - Male';
}

export function getCabinOptionDescription({ type, persons, cabinType }) {
  if (cabinType === CABIN.SOLO_TYPE) {
    if (type === 'girl') {
      return 'For 1 female in a shared cabin - one double bed to share with another female guest assigned by us closer to the trip.';
    }
    return 'For 1 male in a shared cabin - one double bed to share with another male guest assigned by us closer to the trip.';
  }

  if (type === 'mixed') {
    return 'For 1 male and 1 female in 1 private cabin';
  }
  if (type === 'girl') {
    return Number(persons) === 2 ? 'For 2 females in 1 private cabin' : 'For 1 female in 1 private cabin';
  }

  return Number(persons) === 2 ? 'For 2 males in 1 private cabin' : 'For 1 male in 1 private cabin';
}
